module.exports = __webpack_public_path__ + "img/diagramaB.a72bf5b1.svg";